import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import ExcelDragAndDrop from "./ExcelDragAndDrop";
import * as XLSX from 'xlsx';
import headerMapping from "../../../../constants/excelHeaderMapping";

const ExcelUploadModal = ({ isOpen, onClose, onDataParsed, costCenters, expenseGroup, projects, cif, documentLines}) => {

    const toDateCell = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return isNaN(date.getTime()) ? '' : date;
    };

    const downloadTemplate = () => {
        const headers = Object.keys(headerMapping);

        const rows = [headers];

        if (documentLines && documentLines.length > 0) {
            documentLines.forEach((line) => {
                const row = headers.map((header) => {
                    const key = headerMapping[header];
                    const value = line[key];
                    if (key === 'invoicePeriodStartDate' || key === 'invoicePeriodEndDate') {
                        return toDateCell(value);
                    }
                    return value ?? '';
                });
                rows.push(row);
            });
        }

        const worksheet = XLSX.utils.aoa_to_sheet(rows);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

        XLSX.writeFile(workbook, "template.xlsx");
      };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Uploadeaza fisier Excel</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ExcelDragAndDrop
                onDataParsed={(data) => {
                  onDataParsed(data);
                  onClose();
                }}
                projects={projects}
                expenseGroup={expenseGroup}
                costCenters={costCenters}
                cif={cif}
              />
            </ModalBody>
            <ModalFooter>
              <Button 
                colorScheme="green" 
                mr={3} 
                onClick={downloadTemplate}
              >
                Download Template
              </Button>
              <Button colorScheme="blue" onClick={onClose}>
                Inchidere
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      );
    };

export default ExcelUploadModal;